import React from "react";

export default function GalleryPagination({page, pages, nextPage, toPage, isLoading = false}) {
    let showLessDisabled = page <= 1 ? true : undefined;
    let showMoreDisabled = page >= pages ? true : undefined;

    const loading = isLoading ? 'loading' : '';

    const handleShowLess = () => toPage(1);
    const handleShowMore = () => {
        if(isLoading === false) nextPage();
    };

    return(
        <React.StrictMode>
            <button className={`btn showLess`} onClick={handleShowLess} disabled={showLessDisabled}>{seeLessText}</button>
            <button className={`btn showMore ${loading}`} onClick={handleShowMore} disabled={showMoreDisabled}>{seeMoreText}</button>
        </React.StrictMode>
    )
}